import {
  Component,
  computed,
  contentChildren,
  EventEmitter,
  input,
  Input,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

import { IrisIconComponent } from '@sondermind/iris/icon';
import { IrisButtonTypeAttributeOptions, IrisButtonTarget } from '@sondermind/iris/shared';

export enum IrisButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger',
  DANGER_SECONDARY = 'danger-secondary'
}

export enum IrisButtonIconPositions {
  LEFT = 'left',
  RIGHT = 'right'
}

export enum IrisButtonSizes {
  MEDIUM = 'medium',
  SMALL = 'small'
}

@Component({
  selector: 'iris-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class IrisButtonComponent {
  private irisButtonTypes = IrisButtonTypes;
  /**
   * @deprecated
   * Please use the buttonType attribute instead of the type attribute.
   */
  @Input() type: IrisButtonTypes = this.irisButtonTypes.PRIMARY;
  @Input() buttonType!: IrisButtonTypes;
  @Input() typeAttribute: IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions.SUBMIT;
  @Input() disabled: boolean | undefined;
  @Input() linkHref: string | undefined;
  @Input() target: IrisButtonTarget | undefined;
  @Output() click = new EventEmitter();

  readonly iconPosition = input<IrisButtonIconPositions | undefined>(undefined);
  readonly size = input<IrisButtonSizes>(IrisButtonSizes.MEDIUM);

  private readonly projectedIcons = contentChildren(IrisIconComponent);

  buttonClasses!: string;
  irisButtonIconPosition = IrisButtonIconPositions;

  readonly showLeadingIconSlot = computed(
    () => this.iconPosition() === IrisButtonIconPositions.LEFT && this.projectedIcons().length > 0
  );

  readonly showTrailingIconSlot = computed(
    () => this.iconPosition() === IrisButtonIconPositions.RIGHT && this.projectedIcons().length > 0
  );

  onClick(event: Event): void {
    event.stopImmediatePropagation();
    if (!this.disabled) {
      this.click.emit(event);
    }
  }

  ngOnInit(): void {
    const type = this.buttonType ?? this.type;
    this.buttonClasses = this.buildButtonClasses(type);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['buttonType']) {
      this.buttonClasses = this.buildButtonClasses(this.buttonType);
    }
  }

  private buildButtonClasses(type: IrisButtonTypes): string {
    const sizeClass = this.size() === IrisButtonSizes.SMALL ? ' iris-button--small' : '';
    return `iris-button iris-button--${type}${sizeClass}`;
  }
}
